const EventInfo = 1;
const EventDetails = 2;
const LaneConditions = 3;
const Rules = 4;
const Setup = 5;
const Deposit = 6;
const SetupComplete = 7;

export const STEP_SEQUENCE = {
	EventInfo,
	EventDetails,
  LaneConditions,
  Rules,
  Setup,
  Deposit,
  SetupComplete,
}

export default [{
    label:'Event Information',
    current:true,
    disabled:false,
		completed:false,
		sequence:STEP_SEQUENCE.EventInfo,
		component:'EventInfo'
	},
	{
    label:'Event Details',
    current:false,
    disabled:true,
		completed:false,
		sequence:STEP_SEQUENCE.EventDetails,
		component:'EventDetails'
	},
	{
    label:'Lane Conditions',
    current:false,
		disabled:true,
		completed:false,
		sequence:STEP_SEQUENCE.LaneConditions,
		component:'LaneConditions'
	},
	{
    label:'Rules',
    current:false,
    disabled:true,
		completed:false,
		sequence:STEP_SEQUENCE.Rules,
		component:'EventRules'
	},
	{
    label:'Setup',
    current:false,
    disabled:true,
		completed:false,
		sequence:STEP_SEQUENCE.Setup,
		component:'EventSetup'
	},
	{
    label:'Deposit',
    current:false,
    disabled:true,
		completed:false,
		sequence:STEP_SEQUENCE.Deposit,
		component:'Deposit'
	},
	{
    label:'Setup Complete',
    current:false,
    disabled:true,
		completed:false,
		sequence:STEP_SEQUENCE.SetupComplete,
		component:'SetupComplete'
	}
]


// WEBPACK FOOTER //
// ./src/containers/event/logic/wizardSteps.js